<script setup lang="ts">
import type { ManufacturerDto } from '@/api/generator';

defineProps<{
  manufacturer: ManufacturerDto | undefined;
}>();
</script>

<template>
  <div>
    <p class="v-label-overwrite mb-2">
      {{ $t('Manufacturer') }}
    </p>

    <div v-if="manufacturer" class="d-flex align-start ga-2">
      <img
        v-if="manufacturer.icon"
        class="manufacturer-icon"
        :src="`data:image/png;base64,${manufacturer.icon}`"
        alt="Manufacturer"
      />
      <div>
        {{ manufacturer.name }}<br />
        {{ manufacturer.fullName }}<br />
        {{ manufacturer.contactData.street }}<br />
        {{ manufacturer.contactData.city }}<br />
        {{ manufacturer.contactData.phone }}<br />
        <a :href="`mailto:${manufacturer.contactData.email}`">{{
          manufacturer.contactData.email
        }}</a>
        <br />
        <a :href="manufacturer.contactData.website" target="_blank" rel="noopener noreferrer">{{
          manufacturer.contactData.website
        }}</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.manufacturer-icon {
  margin-left: 8px;
  height: 50px;
  flex-shrink: 0;
}
</style>
